import React  from 'react';
import {Button, Dropdown, Flex, MenuProps, Popconfirm, Popover} from "antd";
import {SettingOutlined, UserOutlined} from "@ant-design/icons";
import keycloak from "../../keycloak";
import {t} from "i18next";
import Sider from "antd/lib/layout/Sider";
import Protected from "../../roles/Protected";
import {NavLink} from "react-router-dom";
import IconMenuRegistry from "../ui/icons/IconMenuRegistry";
import IconMenuDiagram from "../ui/icons/IconMenuDiagram";
import IconWorkgroupAction from "../ui/icons/IconWorkgroupAction";
import IconMenuReport from "../ui/icons/IconMenuReport";
import Roles from "../../roles/Roles";

export default function LayoutSider() {
  const siderUserItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <span onClick={() => {
          keycloak.logout()
        }}>
          {t('edit.exit')}
        </span>
      ),
    },
  ];

  return (
    <Sider width={48} className={'layout-sider'}>
      <Flex vertical justify={'space-between'} style={{height: '100%'}}>
        <Flex vertical className={'layout-sider__links'}>
          {Roles.hasAccess('canReadDiagram') &&
            <Flex>
              <Popover placement="right" content={
                <Flex>
                  {t('sidebar.gant')}
                </Flex>
              } overlayClassName={'sider-links__popover'}>
                <Flex align={'center'} gap={'small'}>
                  <NavLink to={{pathname: '/diagram'}} style={{padding: '14px'}}>
                    <IconMenuDiagram />
                  </NavLink>
                </Flex>
              </Popover>
            </Flex>
          }
          <Flex>
            <Popover placement="right" content={
              <Flex>
                {t('sidebar.registry')}
              </Flex>
            } overlayClassName={'sider-links__popover'}>
              <Flex align={'center'} gap={'small'}>
                <NavLink to={{pathname: '/briefs'}} style={{padding: '14px'}}>
                  <IconMenuRegistry />
                </NavLink>
              </Flex>
            </Popover>
          </Flex>
          {Roles.hasAccess('canReadReports') &&
            <Flex>
              <Popover placement="right" content={
                <Flex>
                  {t('sidebar.reports')}
                </Flex>
              } overlayClassName={'sider-links__popover'}>
                <Flex align={'center'} gap={'small'}>
                  <NavLink to={{pathname: '/report'}} style={{padding: '14px'}}>
                    <IconMenuReport />
                  </NavLink>
                </Flex>
              </Popover>
            </Flex>
          }
        </Flex>
        <Flex justify={'flex-end'} vertical  align={'center'} gap={'middle'} style={{padding: '10px'}}>
          <Protected access={'canSetSettings'}>
            <NavLink to={{pathname: '/admin'}}>
              <Button icon={<SettingOutlined />}/>
            </NavLink>
          </Protected>
          <Dropdown menu={{ items: siderUserItems }} placement="topRight">
            <Button icon={<UserOutlined />}/>
          </Dropdown>
        </Flex>
      </Flex>
    </Sider>
  )
}
